import React, { FC } from 'react';
import { Stack } from '@mui/material';
import { HeaderDetailsSkeleton } from './header-details-skeleton';
import { HeaderTitleSkeleton } from './header-title-skeleton';
import { MetricListSkeleton } from './metric-list-skeleton';

export const DashboardHeaderInfoSkeleton: FC = () => {
  return (
    <Stack gap={1}>
      <HeaderTitleSkeleton />
      <HeaderDetailsSkeleton />
      <MetricListSkeleton />
    </Stack>
  );
};
